import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmployeesReportController', EmployeesReportController);

    function EmployeesReportController(
        $scope,
        $timeout,
        BulkModeService,
        CompaniesFactory,
        DateService,
        DownloadFileService,
        FormVerificationService,
        LocalStorageService,
        ReportsFactory
    ) {
        var vm = this;
        var paramsTimeout = $timeout();
        init();

        function init() {
            vm.companyEmployee = LocalStorageService.getCompanyEmployee();
            vm.getEmployees = (companyId, params) => {
                // If CompaniesFactory.readEmployees is not wrapped in that way then
                // this.$http in CompaniesFactory is not defined when paginator
                // try to fetch data.
                return CompaniesFactory.readEmployees(companyId, params);
            };
            vm.areEmployeesAvailable = true;
            vm.getReport = getReport;
            vm.params = { page_size: 50, page: 1 };

            setDefaultDates();
            setWatcher();
        }

        function setWatcher() {
            $scope.$watch(
                function () {
                    return vm.params;
                },
                function () {
                    $timeout.cancel(paramsTimeout);
                    paramsTimeout = $timeout(getEmployees, 300);
                },
                true
            );
        }

        /**
         * Function sets default dates to first and last day of the
         * previous month.
         */
        function setDefaultDates() {
            var today = new Date();
            today.setMonth(today.getMonth() - 1);

            vm.dateFrom = DateService.createDateFormat(
                DateService.getFirstDayOfTheMonth(today)
            );
            vm.dateTo = DateService.createDateFormat(
                DateService.getLastDayOfTheMonth(today)
            );
        }

        function getReport() {
            ReportsFactory.getCompanyEmployeesReport(
                vm.companyEmployee.organization.party_uuid,
                {
                    date_from: vm.dateFrom,
                    date_to: vm.dateTo,
                    id: vm.batchItems,
                }
            ).then(
                function (response) {
                    DownloadFileService.downloadFile(response);
                },
                function (response) {
                    FormVerificationService.error(
                        DownloadFileService.transformArrayBufferToJson(
                            response.data
                        ),
                        vm.form
                    );
                }
            );
        }

        function getEmployees() {
            CompaniesFactory.readEmployees(
                vm.companyEmployee.organization.party_uuid,
                vm.params
            ).then(
                (response) => {
                    vm.areEmployeesAvailable = true;
                    vm.employees = response.data;
                    vm.totalEmployees = response.data.count;
                    enableBulkMode();
                },
                (error) => {
                    if (error.status === 404) {
                        vm.areEmployeesAvailable = false;
                    }
                }
            );
        }

        function enableBulkMode() {
            if (!vm.bulkModeEnabled) {
                BulkModeService.attachBulkModeFunctions(vm, 'employees', 'id');
                vm.enableBulkMode();
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/employees-report/employees-report.controller.ts